import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"padding":"30px"} }
const _hoisted_2 = { class: "pl-24 pr-24" }
const _hoisted_3 = { class: "d-flex flex-row-reverse" }
const _hoisted_4 = {
  class: "d-flex justify-content-between",
  style: {"padding":"30px 0 0 0"}
}
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "parent" }
const _hoisted_7 = { class: "mt-80 mb-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_QuizFilters = _resolveComponent("QuizFilters")!
  const _component_document_card_checkbox = _resolveComponent("document-card-checkbox")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_confirm_delete_modal = _resolveComponent("confirm-delete-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ciena_layout, { "no-sidebar": true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_button, {
                variant: "red",
                class: "ml-18",
                onClick: _ctx.confirmDeleteModal.open
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Delete now", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_base_button, {
                variant: "outlined",
                onClick: _ctx.cancel
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "heading-4 f-roboto fw-light grey-1 mb-32" }, "Delete question to selected Partner", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_base_button, {
                class: "mr-16",
                variant: "outlined",
                onClick: _ctx.selectAll
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Select all", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_base_button, {
                variant: "outlined",
                onClick: _ctx.deselectAll
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Deselect all", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_QuizFilters, { onOnFilterChange: _ctx.onFilterChange }, null, 8, ["onOnFilterChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
              return (_openBlock(), _createElementBlock("div", {
                key: document.id,
                class: "child"
              }, [
                _createVNode(_component_document_card_checkbox, {
                  id: document.id,
                  name: document.name,
                  "gradient-type": document.color,
                  "last-edited": document.updated_at,
                  "filter-values": document.filter_values,
                  "business-function-id": _ctx.businessFunctionId,
                  "is-selected": _ctx.savedQuizIds.indexOf(document.id) !== -1,
                  onOnCheck: _ctx.toggleQuiz,
                  fillColor: "#EB5757"
                }, null, 8, ["id", "name", "gradient-type", "last-edited", "filter-values", "business-function-id", "is-selected", "onOnCheck"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.pageMeta.current_page)
              ? (_openBlock(), _createBlock(_component_pagination, {
                  key: 0,
                  "current-page": _ctx.pageMeta.current_page,
                  "total-pages": _ctx.pageMeta.total,
                  meta: _ctx.pageMeta,
                  onHandleClick: _ctx.navigateToPage
                }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_the_modal, { "is-visible": _ctx.questionCreateConfirmIsOpen }, {
      content: _withCtx(() => [...(_cache[6] || (_cache[6] = [
        _createElementVNode("p", { class: "text-center" }, "Your question has been deleted to selected Partners", -1)
      ]))]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Back to Dashboard", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(_component_confirm_delete_modal, {
      "is-open": _ctx.confirmDeleteModal.isOpen.value,
      title: "Are you sure you want to delete?",
      subtitle: "Type delete to remove question from selected Partners",
      "confirm-button-text": "Delete data",
      onOnConfirm: _ctx.deleteNow,
      onOnCancel: _ctx.confirmDeleteModal.close
    }, null, 8, ["is-open", "onOnConfirm", "onOnCancel"])
  ], 64))
}